import React from 'react';
import { Drawer } from '@mui/material';
import { useAIChat } from '../contexts/AIChatContext';
import { useHasEditPermission } from 'hooks/users/useHasEditPermission';
import { useCurrentProject } from 'hooks/projects/useCurrentProject';
import { useProject } from 'hooks/projects/queries';
import AIChatPanel from './AIChatPanel';
import { useLocation } from 'react-router-dom';
import { BetaModalProvider } from '../modal/BetaModalProvider';
import AIChatBetaModal from './AIChatBetaModal';

const AIChatDrawer = () => {
  const { isOpen, closeChat } = useAIChat();
  const location = useLocation();

  // Check if we're on a transcript route
  const isTranscriptRoute = location.pathname.startsWith('/transcripts/');

  // Get current project ID based on route
  const { projectId } = useCurrentProject();

  // Fetch project data
  const { data: project } = useProject(projectId);

  // Check edit permissions
  const hasEditPermission = useHasEditPermission(project);

  // Don't render the drawer if we're not on a transcript route OR don't have edit permission
  if (!isTranscriptRoute || !hasEditPermission) {
    return null;
  }

  const onRejectTerms = () => {
    closeChat();
  };

  return (
    <BetaModalProvider onReject={onRejectTerms}>
      {isOpen && <AIChatBetaModal />}
      <Drawer
        anchor="right"
        open={isOpen}
        onClose={closeChat}
        variant="persistent"
        sx={{
          width: isOpen ? 400 : 0,
          flexShrink: 0,
          zIndex: 1000, // Below modals (1050) but above normal content
          transition: (theme) => theme.transitions.create('width', {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen,
          }),
          '& .MuiDrawer-paper': {
            width: 400,
            maxWidth: '90vw',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            transition: (theme) => theme.transitions.create('transform', {
              easing: theme.transitions.easing.easeInOut,
              duration: theme.transitions.duration.enteringScreen,
            }),
            transform: isOpen ? 'translateX(0)' : 'translateX(100%)',
          }
        }}
      >
        <AIChatPanel
          onClose={closeChat}
          height="100%"
        />
      </Drawer>
    </BetaModalProvider>
  );
};

export default AIChatDrawer;